module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEESURBVHgBlZLNbcJAEIXnrWMibpZiJI5OB3SAqSApISVYIShHnAISUkJaSAVABUAFcOTgAwckC7Bn2EUyP8bIZqTVzs6+b3Y0s0Q3bN1rtOLPpnfrXhUFN92nV5sxUQnP48D1K4NE1uDoWehXAuP3xpvevOwsBL/oVRzE3aZvSfoigAGMyMnpFnpNdZYpsxrXf5cjGEgRD+kO45Q7utSE7rUHkKj6dzQicFiZEg7tQTRGdt58uH2dJyyDHn+iL+Meuwrgn0qsBvsv89UpGbwycEeJfwVCpJ3TrXT7FxcRodYVmBLNTgIOa+n2mXnbuWgc9CwLS+m5bQmc/PApDhzPfPrz2B7UHVdl3gBq8gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f6.png
// module id = Zg0f
// module chunks = 1